<script>
import ValueChecker from "../services/ValueChecker";
import moment from "moment";
import DateIntervalParser from "@/Models/dateModels/DateIntervalParser.ts";
import {FILTER_DATE_FORMAT} from "@/const";

    export default {
        methods: {
            $buildAttributes(attributesSelected, data, indexName) {
                let attrValues = [];
                const collectValueIds = (collection) => {
                    let values = [];
                    collection.forEach((value) => {
                        values.push(value.id);
                    });

                    return values;
                };

                attributesSelected.forEach((attribute) => {
                    let attributePrototype = {
                        id: attribute.id,
                        type: attribute.type,
                    };

                    switch (attribute.type) {
                        case 2:
                            attributePrototype['min'] = typeof attribute.value[0] === 'number' ? attribute.value[0] : attribute.min;
                            attributePrototype['max'] = typeof attribute.value[1] === 'number' ? attribute.value[1] : attribute.max;
                            break;
                        case 3:
                            attributePrototype['value'] = [attribute.booleanValue ? attribute.checked : attribute.unchecked];
                            attributePrototype['unchecked'] = attribute.unchecked;
                            break;
                        default:
                            if (Array.isArray(attribute.value)) {
                                attributePrototype['value'] = collectValueIds(attribute.value);
                            }
                    }

                    attrValues.push(JSON.stringify(attributePrototype));
                })

                if (attrValues.length > 0) {
                    data[indexName] = attrValues;
                }
            },
            /**
             * Method builds data AJAX param directly from filters
             * @param filters
             * @param data
             * @param requestedFilters
             */
            $buildFilters(filters, data, requestedFilters) {
                filters.forEach(function(filter) {
                    if (requestedFilters && requestedFilters.indexOf(filter.name) === -1) {
                        return;
                    }
                    if (null !== filter.value) {
                        if (filter.type.includes('[]')) {
                            if (!data[filter.name]) {
                                data[filter.name] = [];
                            }
                            if (Array.isArray(filter.value)) {
                                filter.value.forEach(function(v) {
                                    if (typeof v === 'object') {
                                        data[filter.name].push(v.id);
                                    }
                                });
                            } else {
                                data[filter.name].push(filter.value.id);
                            }
                        } else if (filter.type === 'daterange') {
                            if (null !== filter.value.startDate && null !== filter.value.endDate) {
                                let dateIntervalParser = new DateIntervalParser();
                                let dateStartInterval = dateIntervalParser.execute(filter.value.startDate);
                                let startDate = moment(dateStartInterval.getDate()).format(FILTER_DATE_FORMAT);
                                let dateEndIntervalEnd = dateIntervalParser.execute(filter.value.endDate);
                                let endDate = moment(dateEndIntervalEnd.getDate()).format(FILTER_DATE_FORMAT);
                                let dateRange = {
                                    startDate: startDate,
                                    endDate: endDate
                                };
                                data[filter.name] = dateRange;
                            }
                        } else if (filter.type === 'range') {
                            if(undefined === filter.value[0]) {
                                filter.value[0] = null;
                            }
                            data[filter.name] = filter.value;
                        } else if (filter.type === 'date') {
                            let dateIntervalParser = new DateIntervalParser();
                            let dateInterval = dateIntervalParser.execute(filter.value);
                            let date = moment(dateInterval.getDate()).format(FILTER_DATE_FORMAT);
                            filter.value = date;
                            data[filter.name] = date;
                        } else {
                            data[filter.name] = filter.value;
                        }
                    }
                });
            },
            $getFilterByName(filters, name, searchBy) {
                if (!searchBy) {
                    searchBy = 'name';
                }

                let item = filters.filter((v) => {
                  return v[searchBy] === name;
                });

                return item.length > 0 ? item[0] : null;
            },
            $getFilterById(filters, id) {
                return this.$getFilterByName(filters, id, 'id');
            },
            $serialize(filters) {
                let str = [];
                filters.forEach((filter) => {
                    if (Array.isArray(filter.value)) {
                        filter.value.forEach((v) => {
                            str.push(encodeURIComponent(filter.name) + "[]=" + encodeURIComponent(v.id));
                        });
                    } else {
                        str.push(encodeURIComponent(filter.name) + "=" + encodeURIComponent(filter.value));
                    }
                });

                return str.join("&");
            },
            $unSerialize(filters, params) {
                let _this = this;
                Object.entries(params).forEach((param) => {
                    let filter = _this.$getFilterByName(filters, param[0].replace('[]', ''));

                    if (filter) {
                        if (filter.type.includes('[]')) {
                            if (!Array.isArray(filter.value)) {
                                filter.value = [];
                            }

                            if (!_this.$checkExists(filter.value, param[1])) {
                                filter.value.push({id: param[1]});
                            }
                        } else {
                            filter.value = param[1];
                        }
                    }
                });
            },
            $checkExists(values, value) {
                let res = values.filter((v) => {
                     return v.id === parseInt(value);
                });

                return res.length > 0;
            },
            $round(num) {
                return Math.round((num + Number.EPSILON) * 100) / 100;
            },
            $setValueFromQueryString(query, filters) {
                Object.entries(query).forEach(entry => {
                    let [key, value] = entry;
                    let keyName = key.replace('[]', '');
                    let searchBy = 'name';
                    let filter = this.$getFilterByName(filters, keyName, searchBy);

                    if (!filter) {
                        return;
                    }

                    this.$setValue(filter, value);
                });
            },
            $setValueFromQueryStringForAttributes(query, filters, setValueCallback) {
                Object.entries(query).forEach(entry => {
                    let [key, value] = entry;
                    let searchBy = 'id';

                    if (!Array.isArray(value)) {
                        value = [value];
                    }

                    value.forEach((json) => {
                        let parsedValue = JSON.parse(json);
                        let filter = this.$getFilterByName(filters, parsedValue.id, searchBy);

                        if (!filter) {
                            return;
                        }

                        if (filter.type === 2) {
                            parsedValue.value = [parsedValue.min, parsedValue.max];
                        }

                        this.$setValue(filter, parsedValue.value);
                        setValueCallback(filter);
                    });
                });
            },
            $setValue(filter, value) {
                switch (filter.type) {
                    case 1:
                    case 'int[]':
                    case 'string[]':
                        let items = [];
                        let rowItems = [];

                        if (!Array.isArray(value)) {
                            value = [value];
                        }

                        value.forEach(v => {
                            items = items.concat(filter.availableValue.filter((aV) => {
                                if ('rows' in aV) {
                                    rowItems = rowItems.concat(aV.rows.filter((r) => {

                                        return r.id == v;
                                    }));

                                    return false;
                                }

                                return aV.id == v;
                            }));
                        });

                        items = items.concat(rowItems);

                        if (items.length > 0) {
                            filter.value = items;
                        }
                        break;
                    default:
                        filter.value = value;
                }
            },
            $getFilterScalarValue(filter) {
                if (ValueChecker.isArray(filter.value)) {
                    let values = [];
                    filter.value.forEach(v => {
                        if (ValueChecker.isObject(v)) {
                            values.push(v.id);
                        } else {
                            values.push(v);
                        }
                    });

                    return values
                }

                return filter.value;
            },
            $prepareFiltersData(filters) {
                filters.forEach(function (filter, index) {
                    if (null === filter.value) {
                        return;
                    }

                    if ('daterange' !== filter.type) {
                        return;
                    }

                    if (null !== filter.value.startDate && null !== filter.value.endDate) {
                        let dateIntervalParser = new DateIntervalParser();
                        let dateStartInterval = dateIntervalParser.execute(filter.value.startDate);
                        let startDate = moment(dateStartInterval.getDate()).format(FILTER_DATE_FORMAT);
                        let dateEndIntervalEnd = dateIntervalParser.execute(filter.value.endDate);
                        let endDate = moment(dateEndIntervalEnd.getDate()).format(FILTER_DATE_FORMAT);
                        let dateRange = {
                            startDate: startDate,
                            endDate: endDate
                        };
                        filters[index].value = dateRange;
                    }
                });
            }
        }
    };

</script>


// WEBPACK FOOTER //
// FilterMixins.vue?93193794